import Vue from 'vue'
import VbDatePicker from 'components/common/vb-date-picker'
Vue.use(VbDatePicker)
